import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { useCallback } from 'react';

export const initDatadog = () => {
    const enableDatadog = process.env.REACT_APP_ENABLE_DATADOG;
    if (!enableDatadog) return;

    // Initialize Datadog here
    datadogRum.init({
        applicationId: process.env.REACT_APP_DATADOG_RUM_APPLICATION_ID,
        clientToken: process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN,

        // Datadog site configuration (we use US5 region)
        site: 'us5.datadoghq.com',

        // Service identification for filtering in Datadog dashboards
        service: 'patient',

        // Environment tag (currently only enabled for production, see above)
        env: process.env.REACT_APP_AXLE_ENV,

        // Application version for release tracking (currently commented out)
        // version: '1.0.0',

        // Sampling configuration
        sessionSampleRate: 100, // Collect data from 100% of sessions
        sessionReplaySampleRate: 20, // Record session replays for 20% of sessions

        // Feature enablement flags
        trackUserInteractions: true, // Monitor clicks, form submissions, page navigation
        trackResources: true, // Monitor API calls, asset loading, network requests
        trackLongTasks: true, // Detect performance bottlenecks and blocking operations

        // Privacy configuration
        defaultPrivacyLevel: 'allow', // Allow collection of all data (can be 'mask' or 'mask-user-input')

        beforeSend: event => {
            // Scrub sensitive parameters from URLs
            if (event.view && event.view.url) {
                event.view.url = scrubSensitiveParams(event.view.url);
            }
            if (event.view && event.view.referrer) {
                event.view.referrer = scrubSensitiveParams(event.view.referrer);
            }
            return event;
        },
    });

    datadogLogs.init({
        clientToken: process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN,
        site: 'us5.datadoghq.com',
        service: 'patient',
        env: process.env.REACT_APP_AXLE_ENV,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        beforeSend: log => {
            // Scrub sensitive parameters from URLs
            if (log.view && log.view.url) {
                log.view.url = scrubSensitiveParams(log.view.url);
            }
            if (log.view && log.view.referrer) {
                log.view.referrer = scrubSensitiveParams(log.view.referrer);
            }
            return log;
        },
    });

    console.log('Datadog RUM initialized');
};

function scrubSensitiveParams(url) {
    const sensitiveParams = ['xdata'];

    let cleanUrl = url;

    sensitiveParams.forEach(param => {
        // Remove parameter and its value
        const regex = new RegExp(`[?&]${param}=[^&]*`, 'gi');
        cleanUrl = cleanUrl.replace(regex, '');
    });

    // Clean up any leftover ? or & characters
    cleanUrl = cleanUrl.replace(/[?&]$/, '');
    cleanUrl = cleanUrl.replace(/\?&/, '?');

    return cleanUrl;
}

export const useDatadogClickTracking = (elementId, metadata = {}) => {
    const trackClick = useCallback(() => {
        // Send immediately
        datadogRum.addAction('element_click', {
            elementId,
            timestamp: Date.now(),
            ...metadata,
        });
    }, [elementId, metadata]);

    return { trackClick };
};
